
<div class="search-bar" style="padding-top: 10px; padding-left: 20px; padding-right: 20px;">
  <div class="input-group">
    <span class="input-group-text">
      <i class="fas fa-search"></i>
    </span>
    <input [(ngModel)]="searchText" type="text" class="form-control" placeholder="Search Forms" aria-label="Search Col" aria-describedby="addon-wrapping">
    <span (click)="searchText = ''" class="input-group-text" id="basic-addon2">
      <i class="fas fa-times"></i>
    </span>
  </div>
</div>

<div class="wrapper w-100">
  <!-- Sidebar -->
  <nav id="sidebar" [ngClass]="status ? 'active' : ''">
      <div class="close-button" type="button" id="sidebarCollapse" (click)="status=!status">
        <span *ngIf="status"><i class="fas fa-angle-right"></i></span>

        <span *ngIf="!status"><i class="fas fa-angle-left"></i></span>
      </div>


      <ul class="list-unstyled components">

        <li>
          <a (click)="currentCategory = 0" (click)="status=!status" [ngClass]="currentCategory === 0 ? 'active-tab' : ''" >All Forms</a>
        </li>

        <div *ngFor="let item of CategoryItems">
          <li>
            <a (click)="currentCategory = item.categoryId" (click)="status=!status" [ngClass]="currentCategory === (item.categoryId) ? 'active-tab' : ''" >{{item.categoryName}}</a>
          </li>
        </div>


      </ul>

  </nav>


  <div id="content" style="display: flex; flex-direction: column; overflow-x: hidden;">
    @for (item of forms | Categoryfilter: currentCategory | FormFilter: searchText; track item.fileId) {
      <app-form-list-row [formEntry]="item"></app-form-list-row>
    }
  </div>
</div>



